import type { ShopifyAsset, ShopifyAssetResponse } from '~/modules/shopify/types';

import { create } from 'zustand';
interface AssetsStore {
  assets?: ShopifyAssetResponse;
  setAssets: (assets: ShopifyAssetResponse) => void;
  getAssets: () => ShopifyAssetResponse | undefined;
  addAssetByKey: (templateShopify: ShopifyAsset) => void;
}

export const useAssetsStore = create<AssetsStore>()((set, get) => ({
  assets: undefined,
  setAssets: (assets) => set({ assets }),
  getAssets: () => get().assets,
  addAssetByKey: (templateShopify: ShopifyAsset) => {
    const assets = get().assets ?? { templateGPV7: [], templateGPV6: [], templateShopify: [] };
    const currentList = assets.templateShopify ?? [];
    const alreadyExists = currentList.some((t) => t.key === templateShopify.key);
    if (alreadyExists) return;

    set({
      assets: {
        ...assets,
        templateShopify: [...currentList, templateShopify],
      },
    });
  },
}));

export default useAssetsStore;
